/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_order_id = /** @type {(inputs: {}) => string} */ () => {
	return `Odkaz na objednávku`
};

const da_order_id = /** @type {(inputs: {}) => string} */ () => {
	return `Ordre reference`
};

const de_order_id = /** @type {(inputs: {}) => string} */ () => {
	return `Bestellreferenz`
};

const en_order_id = /** @type {(inputs: {}) => string} */ () => {
	return `Order ID`
};

const es_order_id = /** @type {(inputs: {}) => string} */ () => {
	return `Referencia del pedido`
};

const fr_order_id = /** @type {(inputs: {}) => string} */ () => {
	return `Référence de commande`
};

const hu_order_id = /** @type {(inputs: {}) => string} */ () => {
	return `Rendelés referencia`
};

const it_order_id = /** @type {(inputs: {}) => string} */ () => {
	return `Riferimento ordine`
};

const nl_order_id = /** @type {(inputs: {}) => string} */ () => {
	return `Bestelreferentie`
};

const pl_order_id = /** @type {(inputs: {}) => string} */ () => {
	return `Numer zamówienia`
};

const pt_order_id = /** @type {(inputs: {}) => string} */ () => {
	return `Referência do pedido`
};

const sv_order_id = /** @type {(inputs: {}) => string} */ () => {
	return `Orderreferens`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const order_id = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.order_id(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("order_id", locale)
	if (locale === "cs") return cs_order_id(inputs)
	if (locale === "da") return da_order_id(inputs)
	if (locale === "de") return de_order_id(inputs)
	if (locale === "en") return en_order_id(inputs)
	if (locale === "es") return es_order_id(inputs)
	if (locale === "fr") return fr_order_id(inputs)
	if (locale === "hu") return hu_order_id(inputs)
	if (locale === "it") return it_order_id(inputs)
	if (locale === "nl") return nl_order_id(inputs)
	if (locale === "pl") return pl_order_id(inputs)
	if (locale === "pt") return pt_order_id(inputs)
	return sv_order_id(inputs)
};